import {
  CART_EMPTY,
  QANTAS_SET_BURN_CREDENTIALS,
  QANTAS_CLEAR_BURN_CREDENTIALS,
  QANTAS_PROPOSITION_START,
  QANTAS_PROPOSITION_SUCCESS,
  QANTAS_PROPOSITION_FAILURE,
  QANTAS_PROPOSITION_CLEAR,
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  QANTAS_BURN_CLEAR,
} from 'actions/actionConstants'
import {
  DO_QANTAS_BURN,
} from 'actions/apiActionConstants'
import { reducerSwitch, createReducer } from 'lib/reducerUtils'

const initialState: App.LoyaltyState = {
  qantas: {
    burnCredentials: {
      qff: null,
      qffLastName: null,
      token: null,
    },
    proposition: {
      hasError: false,
      error: {},
      fetching: false,
      fetched: false,
      amount: {},
    },
    burn: {
      hasError: false,
      error: {},
      fetching: false,
      fetched: false,
      pointsBurned: null,
      burnCurrencyAmount: null,
    },
  },
}

const apiRequests = reducerSwitch<App.LoyaltyState>({
  [DO_QANTAS_BURN]: state => ({
    qantas: {
      ...state.qantas,
      proposition: {
        ...state.qantas.proposition,
        hasError: false,
        fetching: true,
        fetched: false,
      },
    },
  }),
})

const apiSuccesses = reducerSwitch<App.LoyaltyState>({
  [DO_QANTAS_BURN]: (state, action) => ({
    qantas: {
      ...state.qantas,
      burn: {
        ...state.qantas.burn,
        hasError: false,
        fetching: false,
        fetched: true,
        pointsBurned: action.data.pointsBurned,
        burnCurrencyAmount: action.data.burnCurrencyAmount,
      },
    },
  }),
})

const apiFailures = reducerSwitch<App.LoyaltyState>({
  [DO_QANTAS_BURN]: (state, action) => ({
    qantas: {
      ...state.qantas,
      burn: {
        ...state.qantas.burn,
        hasError: true,
        fetching: false,
        fetched: false,
        error: action.error,
      },
    },
  }),
})

const loyaltyReducer = createReducer<App.LoyaltyState>(initialState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
  [QANTAS_SET_BURN_CREDENTIALS]: (state, action) => ({
    qantas: {
      ...state.qantas,
      burnCredentials: {
        qff: action.data.qff,
        qffLastName: action.data.qffLastName,
        token: action.data.token,
      },
    },
  }),
  [CART_EMPTY]: state => ({
    qantas: {
      ...state.qantas,
      burnCredentials: initialState.qantas.burnCredentials,
    },
  }),
  [QANTAS_CLEAR_BURN_CREDENTIALS]: state => ({
    qantas: {
      ...state.qantas,
      burnCredentials: initialState.qantas.burnCredentials,
    },
  }),
  [QANTAS_PROPOSITION_CLEAR]: state => ({
    qantas: {
      ...state.qantas,
      proposition: initialState.qantas.proposition,
    },
  }),
  [QANTAS_BURN_CLEAR]: state => ({
    qantas: {
      ...state.qantas,
      burn: initialState.qantas.burn,
    },
  }),
  [QANTAS_PROPOSITION_START]: state => ({
    qantas: {
      ...state.qantas,
      proposition: {
        ...state.qantas.proposition,
        hasError: false,
        fetching: true,
        fetched: false,
      },
    },
  }),
  [QANTAS_PROPOSITION_SUCCESS]: (state, action) => ({
    qantas: {
      ...state.qantas,
      proposition: {
        ...state.qantas.proposition,
        hasError: false,
        fetching: false,
        fetched: true,
        amount: action.data.result[0],
      },
    },
  }),
  [QANTAS_PROPOSITION_FAILURE]: (state, action) => ({
    qantas: {
      ...state.qantas,
      proposition: {
        ...state.qantas.proposition,
        hasError: true,
        fetching: false,
        fetched: false,
        error: action.data,
      },
    },
  }),
})

export default loyaltyReducer
